var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.polls),function(poll){return _c('div',{key:poll.pollId,staticClass:"list-entry",on:{"click":function($event){return _vm.$emit('onPollClick', poll.pollId)}}},[_vm._v(_vm._s(poll.texts[_vm.lang]))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }